import React from 'react';
import { Button } from '@capcenter/shared';
import classNames from 'classnames';
import { FilterOption } from '../../../interfaces/filters';

import './ButtonGroup.scss';

interface ButtonGroupProps {
	id: string,
	label?: string,
	wrapperClass?: string,
	callback: (label: string, index: number, option: FilterOption) => unknown;
	options: Array<FilterOption>,
	activeButton: string | number,
	buttonClass?: string,
}

const ButtonGroup = ({ activeButton, buttonClass, id, label, wrapperClass, callback, options }: ButtonGroupProps) => {

	return (
		<div id={id} className={classNames(wrapperClass && wrapperClass)}>
			{label && (
				<div className="cc-btn-group__label cc-font-weight--normal mb-1">{label}</div>
			)}
			<div className="cc-btn-group w-100">
				{options.map((option: FilterOption, index: number) => {
					return (
						<Button
							key={`${id}-${option.label}`}
							label={option.label}
							resetText
							fullWidth
							variant={activeButton === index ? 'filled' : 'outline'}
							color={activeButton === index ? 'secondary' : 'gray'}
							size="sm"
							className={classNames(buttonClass && buttonClass, 'col border-radius')}
							onClick={() => {
								callback(option.label, index, option);
							}}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default ButtonGroup;